export const DOCS_SECTIONS_WITH_SUBSECTIONS = ['sources', 'metrics', 'attributes'] as const;

export type DocsSectionWithSubsections = (typeof DOCS_SECTIONS_WITH_SUBSECTIONS)[number];

export const DOCS_SUBSECTION_IDS: Record<DocsSectionWithSubsections, readonly string[]> = {
  sources: ['section11', 'section12', 'section13'],
  metrics: [
    'gdaScore',
    'vdaScore',
    'MyScore',
    'specificity',
    'pleiotropy',
    'gtap',
    'evindex',
    'historicalScore',
    'normalizedScore',
  ],
  attributes: [
    'section41',
    'section42',
    'section43',
    'section44',
    'section45',
    'section46',
    'section47',
    'section48',
  ],
};

const SUBSECTION_ALIASES: Record<string, string> = {
  geneDisease: 'section11',
  variantDisease: 'section12',
  diseaseDisease: 'section13',
  genes: 'section41',
  variants: 'section42',
  diseases: 'section43',
  chemicals: 'section44',
  references: 'section45',
  genedisease: 'section46',
  'gene-disease': 'section46',
  variantdisease: 'section47',
  'variant-disease': 'section47',
  diseasedisease: 'section48',
  'disease-disease': 'section48',
  myscore: 'MyScore',
  historical: 'historicalScore',
  normalized: 'normalizedScore',
  gtp: 'gtap',
  'gene-therapeutic-area-profile': 'gtap',
};

const ALL_SUBSECTION_IDS = new Set(Object.values(DOCS_SUBSECTION_IDS).flatMap(ids => ids));

export function resolveDocsSubsectionId(raw: string): string {
  const trimmed = raw.trim();
  if (!trimmed) return trimmed;
  const alias = SUBSECTION_ALIASES[trimmed.toLowerCase()];
  if (alias) return alias;
  if (ALL_SUBSECTION_IDS.has(trimmed)) return trimmed;
  return trimmed;
}

export function isDocsSubsectionId(id: string): boolean {
  return ALL_SUBSECTION_IDS.has(resolveDocsSubsectionId(id));
}

export function docsSectionUrl(section: string, subsection?: string): string {
  const params = new URLSearchParams({ section });
  if (subsection) {
    params.set('subsection', resolveDocsSubsectionId(subsection));
  }
  return `/docs?${params.toString()}`;
}
